import React from "react";
import ContactMeJotForm from "./JotForm";

const ContactMe = () => {
  return <ContactMeJotForm />;
};

export default ContactMe;
